import React, { lazy, Suspense } from "react";
import { isEmpty } from "lodash";

import Skeleton from "~/components/loaders/Skeleton";
import ErrorBoundary from "~/components/ErrorBoundary";

const ThreeColumnCards = lazy(() => import("~/components/ThreeColumnCards"));

const ProductCategoryColumnCards = ({ data }) => {
    const {
        columnCardsTitle,
        columnCardsNoMarginBottom,
        columnCardsSectionId,
        columnCardsPerRow,
        columnCards,
    } = data.wpProductCategory.categoryData;

    if (isEmpty(columnCards)) {
        return null;
    }

    return (
        <ErrorBoundary>
            <Suspense fallback={<Skeleton variant="block" />}>
                <ThreeColumnCards
                    {...{
                        sectionTitle: columnCardsTitle,
                        columns: columnCards,
                        noMarginBottom: columnCardsNoMarginBottom,
                        sectionId: columnCardsSectionId,
                        columnsPerRow: columnCardsPerRow,
                    }}
                />
            </Suspense>
        </ErrorBoundary>
    );
};

export default ProductCategoryColumnCards;
